export default __webpack_public_path__ + "static/sprite-102660d420ae512b3495da966714c64f.svg";